import Palette from '@opsbase/lib-palette';
import useCss from '@opsbase/web-css';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import Text from '@opsbase/web-ui/Text/Text';
import React from 'react';
import Button from "@opsbase/web-ui/Button/Button";
import EditIcon from "@opsbase/web-icons/icons/EditIcon";
import i18n from "@opsbase/lib-i18n";
import { Horizontal } from "@opsbase/web-layout/Horizontal";
const makeMyClasses = () => ({
    root: {
        backgroundColor: `${Palette.BackgroundGrey.main} !important`,
        border: `1px solid ${Palette.LineGrey.main}`,
        borderRadius: 8,
        padding: 8,
        // backgroundColor: 'white',
        margin: '4px 0',
        height: 'auto',
    },
});
export function WorkflowDialogColumn(props) {
    const { title, onEdit, children, ...otherProps } = props;
    const myCss = useCss(makeMyClasses);
    return (React.createElement(Vertical, { classes: { root: myCss.root }, gutter: true, ...otherProps },
        React.createElement(Horizontal, { shrink: true, gutter: true },
            React.createElement(Pane, { grow: true },
                React.createElement(Text, { variant: 'h2' },
                    title,
                    "... ")),
            React.createElement(Pane, { shrink: true }, onEdit && (React.createElement(Button, { icon: React.createElement(EditIcon, null), color: Palette.primary, fullWidth: true, label: i18n.t('edit'), onClick: onEdit })))),
        children,
        React.createElement(Pane, { grow: true })));
}
export default WorkflowDialogColumn;
